import { tv } from '@workspace/lib';

export const documentBlockVariants = tv({
  slots: {
    section: 'py-xl md:py-3xl px-md md:px-md-banner',
    layout: 'gap-0 md:gap-4xl',
    image: '',
    accordionWrapper: 'max-w-[509px] md:min-h-91.75',
    accordionRow: 'pt-4 pb-1 border-b-sm pr-2.5 pl-3xs border-b',
    heading: '!text-gray-900 !text-lg font-bold',
    headingExpanded: '!text-primary !text-2xl md:!text-2xl',
    arrow: 'text-gray-900',
    arrowExpanded: 'text-primary',
    divider: 'border-secondary-100',
    dividerExpanded: 'border-primary',
    accordionContent: 'pb-4 pt-5 space-y-[16px] md:space-y-2',
    fileItemLabel: 'text-gray-700',
    fileItemHover: 'hover:text-primary',
  },
});
